// Utilities to map natural-language questions to canonical case field keys
// Supports CW Intake and APS profiles; falls back to generic heuristics.

function normalize(text: string): string {
  return String(text || "")
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

type ContactType = string | undefined | null;

export function mapQuestionToField(
  question: string,
  contactType?: ContactType
): string | undefined {
  const q = normalize(question);
  const type = String(contactType || "Intake").toLowerCase();

  // Child Welfare Intake defaults
  const isAps = /aps|adult/.test(type) || type === "california-aps";

  // Shared patterns
  if (/best phone|phone number|reach you/.test(q)) return "reporterPhone";
  if (/your full name|your name|reporter name/.test(q)) return "reporterName";
  if (/your (current )?address|mailing address|home address/.test(q))
    return "reporterAddress";
  if (/when did (the )?(incident|mistreatment) (occur|happen|happened|occurred)/.test(q))
    return "incidentDate";
  if (/where did (the )?(incident|mistreatment) (occur|happen|happened)/.test(q))
    return "incidentLocation";
  if (/immediate danger|in danger right now|urgent risk/.test(q))
    return "immediateDanger";

  if (!isAps) {
    // Child welfare specific
    if (/child'?s name|kid'?s name|what is the child/.test(q)) return "childName";
    if (/how old is the child|child.*(age|date of birth|dob)/.test(q))
      return "childAgeOrDob";
  } else {
    // APS specific
    if (/(adult|client).*(full )?name|what is the adult/.test(q))
      return "clientName";
    if (/(adult|client).*(age|date of birth|dob)/.test(q))
      return "clientAgeOrDob";
    if (/(adult|client).*(address|located|location)/.test(q))
      return "clientAddress";
  }

  return undefined;
}

export const QuestionMappings = {
  mapQuestionToField,
};


